/* eslint-disable linebreak-style */
/* eslint-disable import/first */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import 'moment/min/locales';
import { verifyChat } from '../../store/actions/chat';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import AlarmOff from '@material-ui/icons/AlarmOff';
import AlarmAdd from '@material-ui/icons/AlarmAdd';
import AccessAlarm from '@material-ui/icons/AccessAlarm';
import CircularProgress from '@material-ui/core/CircularProgress';

import axios from '../../config/axiosInstance';
import timeclockInstance from '../../config/timeclockInstance';

import capitalizeFirstLetter from './utils/CapitalizeFirstLetters';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import HeaderEmployee from './HeaderEmployee';
import RegisterTable from './RegisterComponent';
import LastRegisterTable from './LastRegisterTable';
import { param } from 'jquery';

const jwt = require('jsonwebtoken');

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    display: 'flex',
    padding: theme.spacing(1),
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: theme.palette.text.secondary,
    height: 110,
    borderRadius: 20
  },

  paperContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 20,
  },
});

function Employee(props) {
  const { classes } = props;
  const auth = useSelector((state) => state.auth);
  console.log('auth', auth)
  const [user, setUser] = useState('');
  const [bankHours, setBankHours] = useState();
  const [absences, setAbsences] = useState([]);
  const [ExtraHours, setExtraHours] = useState();
  const hasBankOfHours = false;
  const [lastRegisters, setLastRegisters] = useState([]);
  const [loading, setLoading] = useState(false);

  const companyCode = useSelector((state) => state.auth.companyCode);
  const businessName = useSelector((state) => state.auth.businessName);
  const userName = useSelector((state) => state.auth.userName);

  // const fetchChat = React.useCallback(
  //   async (token) => {
  //     const response = await axios.get('/jivoChat/suportPlanUrl', {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     verifyChat(response.data, companyCode, businessName, userName);
  //   },
  //   [companyCode, businessName, userName]
  // );

  React.useEffect(() => {
    async function fetchData(token) {
      setLoading(true);

      const params = {
        start: moment().startOf('month').format('YYYY-MM-DD'), // Apenas ano, mês e dia
        end: moment().format('YYYY-MM-DD'), // Apenas ano, mês e dia
      };
      const { data } = await axios.post(
        // '/timeSheet/generate/pointSheet/app/v3',
        '/employeeDashboardData',
        params,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const horas = Math.floor(Math.abs(data.bankHoursData != null ? data.bankHoursData.global.bankHoursBalanceTotal : 0) / 60);
      const minutosRestantes = Math.abs(data.bankHoursData != null ? data.bankHoursData.global.bankHoursBalanceTotal : 0) % 60;
      const horasFormatadas = horas.toString().padStart(2, '0');
      const minutosFormatados = minutosRestantes.toString().padStart(2, '0');
      const sinal = (data.bankHoursData != null ? data.bankHoursData.global.bankHoursBalanceTotal : 0) < 0 ? '-' : '';
      const resultadoFormatado = `${sinal}${horasFormatadas}:${minutosFormatados}`;

      // setExtraHours(data?.extraHours?.balanceExtraHours);
      setBankHours(resultadoFormatado);
      absencesFilter(token, params.start, params.end)
      setLastRegisters(data.timeclocks);
      setLoading(false);
    }

    if (auth.token) {
      setUser(auth.userName);
      // companyCode(auth.token);
      fetchData(auth.token);
      // fetchChat(auth.token);
      // absencesFilter(auth.token)
    }
    // eslint-disable-next-line
  }, []);

  async function absencesFilter(token, start, end) {
    // setLoading(true);

    const params = {
      start: moment(start).startOf('month').format('YYYY-MM-DD'), // Apenas ano, mês e dia
      end: moment(end).format('YYYY-MM-DD'), // Apenas ano, mês e dia
    };

    const { data } = await axios.post(
      // '/timeSheet/generate/pointSheet/app/v3',
      '/absencesInPeriod',
      params,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setAbsences(data.absences ? data.absences.items : data)
    console.log('items', data)
  }

  const getName = (employeeName) => {
    if (employeeName) {
      const index = employeeName.indexOf(' ');
      if (index > 0) {
        return capitalizeFirstLetter(employeeName.slice(0, index));
      }
      return capitalizeFirstLetter(employeeName);
    }
  };
  console.log('absences', absences.length)
  console.log('absences', absences)

  return (
    <HeaderEmployee user={user}>
      <Grid container spacing={5} justify="center">
        <Grid item xs={8}>
          <ContentHeader title={`Bem vindo(a), ${getName(user)} `} />
        </Grid>
        <Grid
          item
          xs={4}
          alignItems="flex-end"
          style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          <text style={{ fontSize: 12, marginBottom: 5 }}>
            {' '}
            *Valores sugeridos referentes ao mês anterior
          </text>
        </Grid>
      </Grid>
      <Grid container spacing={5} justify="center">
        <Grid item xs={hasBankOfHours ? 6 : 6}>
          <Paper elevation={2} className={classes.paper}>
            <div className={classes.paperContent}>
              <AlarmOff style={{ fontSize: 30 }} />
              <Typography
                variant="h6"
                style={{ marginLeft: 10 }}
                color="textSecondary"
              >
                Faltas
              </Typography>
            </div>
            <Typography
              variant="h5"
              style={{ marginRight: 20 }}
              color="textSecondary"
            >
              {/* {loading ? <CircularProgress color="primary" /> : absences.lenght} */}
              {absences == 'Sem faltas no periodo' ? '0' : absences.length}
            </Typography>
          </Paper>
        </Grid>
        {/* <Grid item xs={hasBankOfHours ? 4 : 6}>
          <Paper elevation={2} className={classes.paper}>
            <div className={classes.paperContent}>
              <AlarmAdd style={{ fontSize: 30 }} />
              <Typography
                variant="h6"
                style={{ marginLeft: 10 }}
                color="textSecondary"
              >
                Horas Extras
              </Typography>
            </div>
            <Typography
              variant="h5"
              style={{ marginRight: 10 }}
              color="textSecondary"
            >
              {/* {loading ? <CircularProgress color="primary" /> : ExtraHours} */}
        {/* </Typography> */}
        {/* </Paper> */}
        {/* </Grid> */}
        {hasBankOfHours ? (
          <Grid item xs={6}>
            <Paper elevation={2} className={classes.paper}>
              <div className={classes.paperContent}>
                <AccessAlarm style={{ fontSize: 30 }} />
                <Typography
                  variant="h6"
                  style={{ marginLeft: 10 }}
                  color="textSecondary"
                >
                  Banco de Horas
                </Typography>
              </div>
              <Typography
                variant="h5"
                style={{ marginRight: 10 }}
                color="textSecondary"
              >
                {loading ? <CircularProgress color="primary" /> : bankHours}
              </Typography>
            </Paper>
          </Grid>
        ) : (
          <Grid item xs={6}>
            <Paper elevation={2} className={classes.paper}>
              <div className={classes.paperContent}>
                <AccessAlarm style={{ fontSize: 30 }} />
                <Typography
                  variant="h6"
                  style={{ marginLeft: 10 }}
                  color="textSecondary"
                >

                </Typography>
              </div>
              <Typography
                variant="h5"
                style={{ marginRight: 10 }}
                color="textSecondary"
              >
                {/* {loading ? <CircularProgress color="primary" /> : bankHours} */}
              </Typography>
            </Paper>
          </Grid>
        )}
        <Grid item xs={6}>
          <RegisterTable absences={absencesFilter} />
        </Grid>
        <Grid item xs={6}>
          <LastRegisterTable lastRegisters={lastRegisters.reverse()} />
        </Grid>
      </Grid>
    </HeaderEmployee>
  );
}

export default withStyles(styles)(Employee);
